export default __webpack_public_path__ + "bussiness_icon.6e8df27882d040daafe379cc5995eccb.svg";